import { render, staticRenderFns } from "./ControlStockTienda.vue?vue&type=template&id=5fbf66c2&scoped=true"
import script from "./ControlStockTienda.vue?vue&type=script&lang=js"
export * from "./ControlStockTienda.vue?vue&type=script&lang=js"
import style0 from "./ControlStockTienda.vue?vue&type=style&index=0&id=5fbf66c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbf66c2",
  null
  
)

export default component.exports